import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {PackageFieldConfigurationModel} from "../../models/package-field-configuration.model";
import {FieldType} from "../../types/field.type";
import {ValidationType} from "../../types/validation.type";

export class PackageConfigurationInputComponent implements IController {

  value: any;
  field: PackageFieldConfigurationModel;
  name: string;
  onChange: Function;

  public configuredField: { packageFieldId?: string, fieldName: string, value?: string, type: FieldType };
  public readonly fieldTypesMap: typeof FieldType = FieldType;
  public readonly validationTypesMap: typeof ValidationType = ValidationType;


  $onInit() {
    this.configuredField = {
      packageFieldId: this.field.packageFieldId,
      fieldName: this.field.name,
      type: this.field.type
    };
    if (typeof this.value !== "undefined") {
      this.configuredField.value = this.value;
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.value && !changes.value.isFirstChange()) {
      if (typeof this.value !== "undefined") {
        this.configuredField.value = this.value;
        this.configuredField.packageFieldId = this.field?.packageFieldId;
      } else {
        delete this.configuredField.value;
        delete this.configuredField.packageFieldId;
      }
    }
    if (changes.field && !changes.field.isFirstChange()) {
      this.configuredField = {
        packageFieldId: this.field.packageFieldId,
        fieldName: this.field.name,
        type: this.field.type,
        value: this.value
      };
    }
  }

  onDateChange(selectedDate) {
    const configuredFieldCopy = angular.copy(this.configuredField);

    configuredFieldCopy.value = selectedDate
    this.onChange({updatedConfiguredField: configuredFieldCopy})
  }

  onDropdownSingleSelect({value}) {
    const configuredFieldCopy = angular.copy(this.configuredField);

    configuredFieldCopy.value = value
    this.onChange({updatedConfiguredField: configuredFieldCopy})
  }

  onDropdownMultiSelect({values}) {
    const configuredFieldCopy = angular.copy(this.configuredField);

    configuredFieldCopy.value = values
    this.onChange({updatedConfiguredField: configuredFieldCopy})
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationInput', {
    require: {
      form: '^form'
    },
    bindings: {
      // configuredField: '<',
      value: '<',
      field: '<',
      name: '<',
      onChange: '&',
    },
    template: require('./package-configuration-input.html').default,
    controller: PackageConfigurationInputComponent
  });

